import { apiClient } from '@shared/api/client';
import { ApiResponse } from '@shared/api/api.types';
import { AssignUniversityAdminDTO, RevokeUniversityAdminDTO, UniversityAdminDTO } from '../dtos';
import { TenantInfoDTO } from '../../manage/dtos';

// University Admin Management API
export const universityAdminApi = {
  // Assign UNIVERSITY_ADMIN role to a user
  async assignUniversityAdmin(
    data: AssignUniversityAdminDTO
  ): Promise<ApiResponse<UniversityAdminDTO>> {
    return apiClient.post<UniversityAdminDTO>('/user-roles', data);
  },

  // Revoke UNIVERSITY_ADMIN role from a user
  async revokeUniversityAdmin(data: RevokeUniversityAdminDTO): Promise<ApiResponse<void>> {
    return apiClient.post<void>('/user-roles/revoke', data);
  },
};

// Tenant Info API
export const tenantInfoApi = {
  // Get tenant information (university details)
  async getTenantInfo(tenantId: string): Promise<ApiResponse<TenantInfoDTO>> {
    return apiClient.get<TenantInfoDTO>(`/tenants/${tenantId}`);
  },
};

// University Admin Management API - Only keeping the removal functionality
export const universityAdminManagementApi = {
  // Remove university admin role (but keep user)
  async removeUniversityAdminRole(
    _userId: string,
    _tenantId: string,
    userRoleId: string
  ): Promise<ApiResponse<void>> {
    return apiClient.delete<void>(`/user-roles/${userRoleId}`);
  },
};

// Export all APIs
export const tenantApi = {
  universityAdmin: universityAdminApi,
  tenantInfo: tenantInfoApi,
  universityAdminManagement: universityAdminManagementApi,
};
